export const scrollHeightBase = 'calc(100vh - 80px - 90px - 120px)'
